import { jsx as _jsx } from "react/jsx-runtime";
export default function VehicleNameDisplay({ testId, vehicle }) {
    return (_jsx("div", { className: "text-heading text-base leading-4 font-medium", "data-testid": testId, children: vehicle.name }));
}
